// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-step.AllOfUs .continue-button,
.survey-step.AllOfUs .continue-button:hover 
{
	background: linear-gradient(to right, #f38d7a 0%,#f8c954 100%);
	color: #262262;
	text-transform: uppercase;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	letter-spacing: .25em;
	width: 100%;
}

.survey-step.AllOfUs .continue-button:disabled 
{
	border: solid 1px #d1d1d1;
	background: #FFF;
	color: #999;
	cursor: default;
}

.survey-step.AllOfUs .step-content .step-title 
{
	font-weight: bold;
	color: #262262;
}`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/SurveyThemes.css"],"names":[],"mappings":"AAAA;;;CAGC,8DAA8D;CAC9D,cAAc;CACd,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,qBAAqB;CACrB,WAAW;AACZ;;AAEA;;CAEC,yBAAyB;CACzB,gBAAgB;CAChB,WAAW;CACX,eAAe;AAChB;;AAEA;;CAEC,iBAAiB;CACjB,cAAc;AACf","sourcesContent":[".survey-step.AllOfUs .continue-button,\n.survey-step.AllOfUs .continue-button:hover \n{\n\tbackground: linear-gradient(to right, #f38d7a 0%,#f8c954 100%);\n\tcolor: #262262;\n\ttext-transform: uppercase;\n\tborder: none;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\tletter-spacing: .25em;\n\twidth: 100%;\n}\n\n.survey-step.AllOfUs .continue-button:disabled \n{\n\tborder: solid 1px #d1d1d1;\n\tbackground: #FFF;\n\tcolor: #999;\n\tcursor: default;\n}\n\n.survey-step.AllOfUs .step-content .step-title \n{\n\tfont-weight: bold;\n\tcolor: #262262;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
